module.exports = __webpack_public_path__ + "761fc6516d7a44e9c3f8675287a48dac.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-62.svg
// module id = 589
// module chunks = 0